<template>
  <b-card-group deck>
    <b-card class="card-estatisticas-beneficios" bg-variant="yellow">
      <div class="d-flex">
        <h5 class="card-title text-uppercase mb-0">Média</h5>
        <font-awesome-icon icon="chart-pie" class="ml-auto" />
      </div>

      <div class="h2 font-weight-bold mb-0 text-nowrap">
        R$ {{ media | number_format }}
      </div>
    </b-card>

    <b-card
      class="card-estatisticas-beneficios"
      bg-variant="green"
      text-variant="white"
    >
      <div class="d-flex">
        <h5 class="card-title text-uppercase text-white mb-0">Maior</h5>
        <font-awesome-icon icon="arrow-trend-up" class="ml-auto" />
      </div>
      <div class="h2 font-weight-bold mb-0 text-white text-nowrap">
        R$ {{ maior | number_format }}
      </div>
    </b-card>

    <b-card
      class="card-estatisticas-beneficios"
      bg-variant="danger"
      text-variant="white"
    >
      <div class="d-flex">
        <h5 class="card-title text-uppercase text-white mb-0">Menor</h5>
        <font-awesome-icon icon="arrow-trend-down" class="ml-auto" />
      </div>
      <div class="h2 font-weight-bold mb-0 text-white text-nowrap">
        R$ {{ menor | number_format }}
      </div>
    </b-card>

    <b-card
      class="card-estatisticas-beneficios"
      bg-variant="exitos"
      text-variant="white"
    >
      <div class="d-flex">
        <h5 class="card-title text-uppercase text-white mb-0">Total</h5>
        <font-awesome-icon icon="plus" class="ml-auto" />
      </div>
      <div class="h2 font-weight-bold mb-0 text-white text-nowrap">
        R$ {{ total | number_format }}
      </div>
    </b-card>
  </b-card-group>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("oportunidades", ["oportunidade", "oportunidade_estatisticas"]),
    media() {
      let value =
        (this.oportunidade_estatisticas.beneficios.media +
          this.oportunidade_estatisticas.beneficios_concedente.media +
          this.oportunidade_estatisticas.emendas.media) /
        3;
      return value;
    },
    maior() {
      let value = 0;
      value =
        value < this.oportunidade_estatisticas.beneficios.max
          ? this.oportunidade_estatisticas.beneficios.max
          : value;

      value =
        value < this.oportunidade_estatisticas.beneficios_concedente.max
          ? this.oportunidade_estatisticas.beneficios_concedente.max
          : value;

      value =
        value < this.oportunidade_estatisticas.emendas.max
          ? this.oportunidade_estatisticas.emendas.max
          : value;

      return value;
    },
    menor() {
      let value = this.maior;
      value =
        value > this.oportunidade_estatisticas.beneficios.min
          ? this.oportunidade_estatisticas.beneficios.min
          : value;

      value =
        value > this.oportunidade_estatisticas.beneficios_concedente.min
          ? this.oportunidade_estatisticas.beneficios_concedente.min
          : value;

      value =
        value > this.oportunidade_estatisticas.emendas.min
          ? this.oportunidade_estatisticas.emendas.min
          : value;

      return value;
    },
    total() {
      let value =
        this.oportunidade_estatisticas.beneficios.total +
        this.oportunidade_estatisticas.beneficios_concedente.total +
        this.oportunidade_estatisticas.emendas.total;

      if (!this.oportunidade.valor_total_calculado) {
        value += this.oportunidade.valor_total;
      }

      return value;
    },
  },
};
</script>

<style lang="scss">
.card-estatisticas-beneficios {
  .card-body {
    padding: 0.3em 0.5em !important;
    margin: 0;
  }
}
</style>
